import { render } from "./chat_tab.vue?vue&type=template&id=becd5ea6"
import script from "./chat_tab.vue?vue&type=script&lang=js"
export * from "./chat_tab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__